import { Component, OnInit, OnDestroy } from '@angular/core';
import { SEASONAL } from 'src/app/constant/auto/seasonal.constant';

const POPUP_STORAGE_KEY = 'seasonal_popup_skip_date';

/** Update this list when seasonal images are added/removed from assets/img/home-carousal/ */
export const SEASONAL_IMAGES= SEASONAL;

@Component({
  standalone: false,
  selector: 'app-seasonal-popup',
  templateUrl: './seasonal-popup.component.html',
  styleUrls: ['./seasonal-popup.component.css']
})
export class SeasonalPopupComponent implements OnInit, OnDestroy {

  readonly images = SEASONAL_IMAGES;
  visible = false;
  currentIndex = 0;

  private slideInterval: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    if (this.images.length === 0) { return; }

    const skippedDate = localStorage.getItem(POPUP_STORAGE_KEY);
    const today = new Date().toDateString();

    if (skippedDate !== today) {
      this.visible = true;
      this.startSlideShow();
    }
  }

  ngOnDestroy(): void {
    this.stopSlideShow();
  }

  private startSlideShow(): void {
    this.slideInterval = setInterval(() => this.next(), 4000);
  }

  private stopSlideShow(): void {
    if (this.slideInterval !== null) {
      clearInterval(this.slideInterval);
      this.slideInterval = null;
    }
  }

  next(): void {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  prev(): void {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
  }

  goTo(index: number): void {
    this.currentIndex = index;
  }

  close(): void {
    this.stopSlideShow();
    this.visible = false;
  }

  skipForToday(): void {
    this.stopSlideShow();
    this.visible = false;
    localStorage.setItem(POPUP_STORAGE_KEY, new Date().toDateString());
  }
}
